import * as permifyConstants from '@repo/api/permify/constants';
import { create } from 'zustand';

export interface ViewPermission {
  name: string;
  value: boolean;
}

type PermissionsMap = Record<string, boolean>;

export interface PermissionsStore {
  data: PermissionsMap;
  setPermissions: (permissions: ViewPermission[]) => void;
  clearPermissions: () => void;
  isAdmin: () => boolean;
}

export const store = create<PermissionsStore>((set, get) => ({
  data: {},
  setPermissions: (permissions: ViewPermission[]) => {
    const permissionsMap = permissions.reduce((acc, { name, value }) => {
      acc[name] = value;
      return acc;
    }, {} as PermissionsMap);

    set((state) => ({ ...state, data: permissionsMap }));
  },
  clearPermissions: () => {
    set((state) => ({ ...state, data: {} }));
  },
  isAdmin: () => {
    const { data } = get();
    return Object.entries(data).some(([key, value]) => {
      return (
        key === permifyConstants.permissions.openCalls.bulkAction &&
        value === true
      );
    });
  },
}));
